import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 *  PervalValidators defines simple validators.
 */
export class PervalValidators {
  /**
   * Email validator.
   *
   * If the value is null or an empty string it is considered as valid.
   * Otherwise if the value contains a text, it executes the regexp email validator.
   */

  static email(control: AbstractControl): ValidationErrors | null {
    const EMAIL_REGEXP: RegExp =
      // eslint-disable-next-line no-useless-escape
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    const _value = control.value;

    if (!_value) {
      return null;
    }

    if (_value !== _value.toLowerCase()) {
      return { email: true };
    }

    return EMAIL_REGEXP.test(_value) ? null : { email: true };
  }

  static frenchPhoneNumber(control: AbstractControl): ValidationErrors | null {
    const PHONE_REGEXP: RegExp = /^(?:\+33|0)[1-9](?:[.\- ]?[0-9]{2}){4}$/;

    const _value = control.value;

    if (!_value) {
      return null;
    }

    return PHONE_REGEXP.test(_value) ? null : { frenchPhoneNumber: true };
  }

  static worldPhoneNumber(control: AbstractControl): ValidationErrors | null {
    const PHONE_REGEXP: RegExp = /^(?=.{6,20}$)\+?[0-9.\-\s]+$/;

    const value = control.value?.trim();

    if (!value) {
      return null;
    }

    return PHONE_REGEXP.test(value) ? null : { worldPhoneNumber: true };
  }

  static vatNumber(control: AbstractControl): ValidationErrors | null {
    const VAT_REGEXP: RegExp = /^[A-Z]{2}[A-Z0-9]{4,12}$/;

    const value = control.value;

    if (!value) {
      return null;
    }

    return VAT_REGEXP.test(value) ? null : { vatNumber: true };
  }

  static siret(control: AbstractControl): ValidationErrors | null {
    const SIRET_REGEXP: RegExp = /^\d{14}$/;

    const value = control.value;

    if (!value) {
      return null;
    }

    return SIRET_REGEXP.test(value) ? null : { siret: true };
  }

  static requiredIf(
    predicate: (formValue: any) => boolean,
    errorKey = 'required',
  ): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.parent) {
        return null;
      }

      const shouldBeRequired = predicate(control.parent.value);
      const value = control.value;

      if (!shouldBeRequired) {
        return null;
      }

      const isEmpty = value === null || value === undefined || value === '';

      return isEmpty ? { [errorKey]: true } : null;
    };
  }

  static firstname(control: AbstractControl): ValidationErrors | null {
    const NAME_REGEXP: RegExp = /^[A-Za-zÀ-ÖØ-öø-ÿ' -]+$/;

    const value = control.value;

    if (!value) {
      return null;
    }

    return NAME_REGEXP.test(value) ? null : { firstname: true };
  }

  static lastname(control: AbstractControl): ValidationErrors | null {
    const NAME_REGEXP: RegExp = /^[A-Za-zÀ-ÖØ-öø-ÿ' -]+$/;

    const value = control.value;

    if (!value) {
      return null;
    }

    return NAME_REGEXP.test(value) ? null : { lastname: true };
  }

  static referencesValidator(
    control: AbstractControl,
  ): ValidationErrors | null {
    const REFERENCES_REGEXP: RegExp = /^[^\\/:*?"<>|\s]+$/;

    const value = control.value;

    if (!value) {
      return null;
    }

    return REFERENCES_REGEXP.test(value) ? null : { referencesValidator: true };
  }

  static oneOf(allowedValues: string[]): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;

      if (!value) {
        return null;
      }

      return allowedValues.includes(value) ? null : { invalidOption: true };
    };
  }
}
